import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { usePortalAuthStore } from '@/stores/portalAuthStore';

/**
 * Guards the client-portal routes (epic 128). Bounces to /portal/login when
 * there is no live portal session — independent of the staff ProtectedRoute, so
 * an operator's staff session never grants portal access and vice-versa.
 */
export function PortalProtectedRoute({ children }: { children: ReactNode }) {
  const isAuthenticated = usePortalAuthStore((s) => s.isAuthenticated());
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/portal/login" replace state={{ from: location }} />;
  }
  return <>{children}</>;
}
